import React, { useState, useEffect } from 'react'
import Button from '../../../../atoms/Button/Button'
import FormCheckbox from '../../../../atoms/FormCheckbox/FormCheckbox'
import { trackingGAEventProdotto } from '../../../../../utils/gtm'
import { priceNotation } from '../../../../../utils/safe'
import useTrans from '../../../../../hooks/useTrans'

const TipoConfezionamento = ({ obj, props, setStep, step }) => {
  const t = useTrans()

  const [Riconfezionamento, setRiconfezionamento] = useState(props.values.riconfezionamento)
  const _descrizione = props?.values?.prodotto
    ? props?.values?.prodotto?.attributi_lista.filter(
        (attributo) => attributo?.attributo_chiave === 'confezionamento'
      )
    : null
  const _riconfezionamento =
    props.values.posizioni[0]?.personalizzazione?.length > 0
      ? props.values.posizioni[0]?.personalizzazione[0][0].riconfezionamento
      : props.values.posizioni[0]?.personalizzazione.riconfezionamento

  const _prezzo =
    props.values.posizioni[0]?.personalizzazione?.length > 0
      ? props.values.posizioni[0]?.personalizzazione[0][0]?.prezzo_confezionamento
      : props.values.posizioni[0]?.personalizzazione?.prezzo_confezionamento

  useEffect(() => {
    try {
      if (
        obj?.tecniche?.[0]?.posizioni[0]?.numero_colori?.[0]?.personalizzazioni_objects?.[0]
          ?.altezza_massima === 0
      ) {
        {
          /* L'utente passa sempre da questo step, quindi di conseguenza nel caso in cui altezza massima 0 allora setto il valore altezza del form a 0 */
        }
        props.values.posizioni?.[0]?.altezza === 0.116 &&
          props.setFieldValue(`posizioni[${0}].altezza`, 0)
        props.values.posizioni?.[1]?.altezza === 0.116 &&
          props.setFieldValue(`posizioni[${1}].altezza`, 0)

        props?.validateForm()
      }
    } catch (error) {}

    _riconfezionamento === 'D'
      ? ((props.values.riconfezionamento = true), setRiconfezionamento(true))
      : ''

    _riconfezionamento === 'N'
      ? ((props.values.riconfezionamento = false), setRiconfezionamento(false))
      : ''

    _riconfezionamento === 'S'
      ? ((props.values.riconfezionamento = false), setRiconfezionamento(false))
      : ''
  }, [])

  const _handleConferma = () => {
    props.values.riconfezionamento = Riconfezionamento
    setStep(step + 1)
  }

  return (
    <div className="confezionamento__stampa">
      <div className="confezionamento__stampa__content">
        <p style={{ marginTop: 10 }}>
          {/* @TODO QUA CI VA IL CONFEZIONAMENTO!!! non abbiamo ancora l'info */}
          {/* Consegnato sfuso, piegatura nella sua bustina opzionale. */}
          {_descrizione
            ? _descrizione.length > 0
              ? _descrizione[0]?.nome
              : obj?.tipo_confezionamento?.nome
            : obj?.tipo_confezionamento?.nome}
        </p>
      </div>

      {_riconfezionamento === 'D' ? null : _riconfezionamento === 'N' ? null : ( // </div> //   </div> //     {/* <FormCheckbox label="Confezionamento di Default" checked={true} /> */} //     <Trans chiave="Confezionamento di Default" /> //   <div> // <div className="confezionamento__stampa__content">
        // <div>
        //   <Trans chiave="Nessun confezionamento disponibile" />
        //   {/* <FormCheckbox
        //     label={`Nessun confezionamento disponibile`}
        //     type="checkbox"
        //     checked={false}
        //     disabled={true}
        //   ></FormCheckbox> */}
        // </div>
        <div>
          <FormCheckbox
            label={t('Richiedi Confezionamento per') + ' ' + `${priceNotation(_prezzo, 3)} €`}
            type="checkbox"
            checked={Riconfezionamento}
            onChange={(e) => setRiconfezionamento(e.target.checked ? true : false)}
          ></FormCheckbox>
        </div>
      )}
      {Riconfezionamento !== null && (
        <Button
          label={t('Conferma confezionamento')}
          variant="primary"
          size="medium"
          onClick={() => {
            _handleConferma()
            const first_articolo =
              props?.values?.prodotto?.articoli.length > 0
                ? props?.values?.prodotto?.articoli[0]
                : null
            trackingGAEventProdotto(
              'customization_funnel',
              'c_step3_confezionamento',
              undefined,
              first_articolo?.titolo || '',
              props?.values?.prodotto?.codice || ''
            )
          }}
        />
      )}
    </div>
  )
}

export default TipoConfezionamento
